import { render, staticRenderFns } from "./PauseTypeList.vue?vue&type=template&id=21da738a&scoped=true&"
import script from "./PauseTypeList.vue?vue&type=script&lang=js&"
export * from "./PauseTypeList.vue?vue&type=script&lang=js&"
import style0 from "./PauseTypeList.vue?vue&type=style&index=0&id=21da738a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da738a",
  null
  
)

export default component.exports